<div class="video-upload-form-builder" [formGroup]="form">
  <div class="form-group">
    <label class="parent-label" *ngIf="field?.label">
      {{ field.label }}{{ field.validation?.required ? '*' : '' }}
    </label>
    <div class="uploadContainer">
      <div
        *ngIf="!hasPreview"
        (click)="fileInput.click()"
        class="uploadFile custom-label-upload banner-type2"
        role="button"
        tabindex="0"
      >
        <input
          #fileInput
          (click)="$event.stopPropagation(); fileInput.value = null"
          (change)="fileChangeEvent($event)"
          type="file"
          class="upload"
          [accept]="application.VIDEO_ACCEPT_TYPES"
          style="display: none"
          appMobileBridgeFileInput
          (mobileFileChange)="mobileFileChangeEvent($event)"
          [fileConfig]="{ isMultiple: false, cropperOptions: null }"
        />
        <div class="video-upload-type2">
          <em class="icon-litebanner-upload"></em>
          <div class="image-title">{{ uploadTitle }}</div>
          <div class="image-msg">{{ application.VIDEO_LIMIT_MSG }}</div>
          <app-button
            [btnField]="{
              type: 'button',
              label: selectLabel,
              class: 'btn btn-primary select-file-btn'
            }"
          ></app-button>
        </div>
      </div>

      <div *ngIf="hasPreview" class="uploadFileImageData">
        <div
          *ngIf="showProgress && cs.isBrowser"
          class="show-progress-bar pointer-none"
        >
          <circle-progress
            [percent]="percent"
            [radius]="23"
            [outerStrokeWidth]="3"
            [innerStrokeWidth]="3"
            [outerStrokeColor]="
              cs.isWhiteLabelWeb
                ? cs.whiteLabelData?.data?.whiteLabel?.theme_color
                : '#09c6da'
            "
            [innerStrokeColor]="'#47665f'"
            [animation]="false"
            [animationDuration]="300"
            [showSubtitle]="false"
            [backgroundPadding]="0"
            [titleFontSize]="10"
            [titleColor]="'#ffffff'"
            [unitsColor]="'#ffffff'"
            [space]="-3"
          ></circle-progress>
        </div>
        <video
          appDisableRightClick
          class="video-upload__preview"
          [src]="currentVideoPreviewSrc"
          [poster]="currentPosterPreviewSrc"
          controls
          playsinline
        ></video>
        <a (click)="removeVideo()" class="close" style="z-index: 10">&times;</a>
      </div>
    </div>
  </div>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
